import { Box } from './styles/Box';

type TProps = {
  paymentIntent: { url: string };
};

export const PaymentIntentBox = ({ paymentIntent }: TProps) => {
  if (!paymentIntent?.url) {
    return null;
  }
  return (
    <Box>
      <iframe src={paymentIntent.url} width={600} height={600} title="frame"></iframe>
    </Box>
  );
};
